import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';

export interface InfobipAvailableNumber {
  numberKey?: string;
  number: string;
  country?: string;
  type?: string;
  shared?: boolean;
  capabilities?: string[];
  price?: {
    pricePerMonth?: number;
    initialMonthlyPrice?: number;
    setupPrice?: number;
    currency?: string;
  };
}

export interface InfobipAvailableNumbersResponse {
  numbers: InfobipAvailableNumber[];
}

export interface InfobipPurchaseRequest {
  numberKey: string;
}

export interface InfobipPurchasedNumber {
  numberKey?: string;
  number: string;
  country?: string;
  type?: string;
}

export interface InfobipPurchaseRequestBody {
  numberOfferKey: string;
  numberType?: string;
  capabilities?: string[];
  countryCode?: string;
  quantity?: number;
  state?: string;
  areaCode?: string;
}

export interface InfobipPurchaseRequestResult {
  id: string;
}

export interface InfobipApplicationNumberResource {
  resourceId: string;
  resourceType: string;
  channel: string;
  applicationId: string;
  entityId: string | null;
  number: string;
  countryNames: string[];
  numberType: string;
}

export interface InfobipApplicationNumbersResponse {
  results: InfobipApplicationNumberResource[];
  paging: { page: number; size: number; totalPages: number; totalResults: number };
}

export interface InfobipVoiceForwardResult {
  number: string;
  status: 'set' | 'unchanged' | 'cleared' | 'skipped' | 'error';
  forwardPhone?: string;
  message?: string;
}

@Injectable({ providedIn: 'root' })
export class InfobipNumbersService {
  private API_URL = '/api/sms/infobip';
  private headerOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  constructor(private httpClient: HttpClient) { }


  searchAvailable(params: { countryCode?: string; areaCode?: string; capabilities?: string; numberType?: string; } = {}): Observable<InfobipAvailableNumbersResponse> {
    let httpParams = new HttpParams();
    if (params.countryCode) httpParams = httpParams.set('countryCode', params.countryCode);
    if (params.areaCode) httpParams = httpParams.set('areaCode', params.areaCode);
    if (params.capabilities) httpParams = httpParams.set('capabilities', params.capabilities);
    if (params.numberType) httpParams = httpParams.set('numberType', params.numberType);

    return this.httpClient.get<InfobipAvailableNumbersResponse>(`${this.API_URL}/available-numbers`, { params: httpParams });
  }


  purchase(numberKey: string): Observable<InfobipPurchasedNumber> {
    return this.httpClient.post<InfobipPurchasedNumber>(`${this.API_URL}/purchase-number`, JSON.stringify({ numberKey }), this.headerOptions);
  }


  submitPurchaseRequest(body: InfobipPurchaseRequestBody): Observable<InfobipPurchaseRequestResult> {
    return this.httpClient.post<InfobipPurchaseRequestResult>(`${this.API_URL}/request-number`, JSON.stringify(body), this.headerOptions);
  }


  listApplicationNumbers(params: { page?: number; size?: number } = {}): Observable<InfobipApplicationNumbersResponse> {
    let httpParams = new HttpParams();
    if (params.page != null) httpParams = httpParams.set('page', String(params.page));
    if (params.size != null) httpParams = httpParams.set('size', String(params.size));
    return this.httpClient.get<InfobipApplicationNumbersResponse>(`${this.API_URL}/application-numbers`, { params: httpParams });
  }


  syncCampaignNumbers(): Observable<{ numberKeys: string[]; skipped?: boolean }> {
    return this.httpClient.post<{ numberKeys: string[]; skipped?: boolean }>(`${this.API_URL}/sync-campaign-numbers`, '{}', this.headerOptions);
  }


  syncVoiceForwarding(): Observable<{ results: InfobipVoiceForwardResult[] }> {
    return this.httpClient.post<{ results: InfobipVoiceForwardResult[] }>(`${this.API_URL}/sync-voice-forwarding`, '{}', this.headerOptions);
  }
}
